import { ApiHelper } from "../../api/index";
import { DbtDocsShareDetails } from "../collaboration/types";
import { User } from "../../user/types";
import {
  Conversation,
  ConversationGroup,
} from "../collaboration/conversations/context/types";

// Dbt docs conversation apis
export const getDbtDocsShareDetailsById = (
  shareId: DbtDocsShareDetails["share_id"],
) => ApiHelper.get<DbtDocsShareDetails | null>(`dbt/dbt_docs_share/${shareId}`);

export const createNewConversationGroup = (
  shareId: DbtDocsShareDetails["share_id"],
  data: Partial<ConversationGroup> & { message: string },
  source: string,
) =>
  ApiHelper.post<{
    conversation_group_id: ConversationGroup["conversation_group_id"];
  }>(`dbt/dbt_docs_share/${shareId}/conversation_group`, {
    ...data,
    telemetry: {
      eventName: "dbtCollaboration:create",
      properties: { source },
    },
  });

export const addConversationToGroup = (
  shareId: DbtDocsShareDetails["share_id"],
  conversationGroupId: ConversationGroup["conversation_group_id"],
  data: Partial<Conversation>,
  source: string,
) =>
  ApiHelper.post(
    `dbt/dbt_docs_share/${shareId}/conversation_group/${conversationGroupId}/conversation`,
    {
      ...data,
      telemetry: {
        eventName: "dbtCollaboration:reply",
        properties: { source },
      },
    },
  );

export const getConversationsByShareId = (
  shareId: DbtDocsShareDetails["share_id"],
) =>
  ApiHelper.get<{ dbt_docs_share_conversations: ConversationGroup[] }>(
    `dbt/dbt_docs_share/${shareId}/conversations`,
  );

export const getUserList = (company?: string) =>
  ApiHelper.get<User[]>("users/chat", { company });

export const resolveConversationGroup = (
  shareId: DbtDocsShareDetails["share_id"],
  conversationGroupId: ConversationGroup["conversation_group_id"],
  source: string,
) =>
  ApiHelper.post(
    `dbt/dbt_docs_share/${shareId}/conversation_group/${conversationGroupId}/resolve`,
    {
      resolved: true,
      telemetry: {
        eventName: "dbtCollaboration:resolve",
        properties: { source },
      },
    },
  );
